<script lang="ts" module>
	import type { ISbStoryData } from '@storyblok/js';

	export interface ItemProps {
		content: ISbStoryData<{
			text: string;
		}>['content'];
	}
</script>

<script lang="ts">
	let { content }: ItemProps = $props();
</script>

<li>{content.text}</li>
